import { wrapper, createApiClient, Result, ApiError } from "../base";
import DocumentAlertDO = App.Data.Alerts.DocumentAlertDO;
import { LaravelPaginatedCollection } from "@/types/collections";
import DocumentAlertPatchDTO = App.Data.Alerts.DocumentAlertPatchDTO;
import DocumentAlertNotifiableDO = App.Data.Alerts.DocumentAlertNotifiableDO;

const baseClient = createApiClient();

export default class {
	get(params: {
		page: number;
		itemsPerPage: number;
		sortBy: { key: string; order: "asc" | "desc" }[];
	}): Promise<Result<LaravelPaginatedCollection<DocumentAlertDO>, ApiError>> {
		let sortBy = undefined;
		if (params.sortBy.length > 0) {
			sortBy =
				params.sortBy[0].order === "desc"
					? `-${params.sortBy[0].key}`
					: params.sortBy[0].key;
		}

		return wrapper(
			baseClient.get("alerts", {
				params: {
					page: params.page,
					per_page: params.itemsPerPage,
					sort: sortBy,
				},
			})
		);
	}

	getChecks(
		alertId: number,
		params: {
			page: number;
			itemsPerPage: number;
			sortBy: { key: string; order: "asc" | "desc" }[];
		}
	): Promise<Result<LaravelPaginatedCollection<DocumentAlertDO>, ApiError>> {
		let sortBy = undefined;
		if (params.sortBy.length > 0) {
			sortBy =
				params.sortBy[0].order === "desc"
					? `-${params.sortBy[0].key}`
					: params.sortBy[0].key;
		}

		return wrapper(
			baseClient.get(`alerts/${alertId}/checks`, {
				params: {
					page: params.page,
					per_page: params.itemsPerPage,
					sort: sortBy,
				},
			})
		);
	}

	getActiveAlertsInAlert(): Promise<Result<Number, ApiError>> {
		return wrapper(baseClient.get(`alerts/get-active-alerts-in-alert`));
	}

	getOne(id: number) {
		return wrapper<DocumentAlertDO>(baseClient.get(`alerts/${id}`));
	}

	create(
		documentAlert: App.Data.Alerts.DocumentAlertDO
	): Promise<Result<App.Data.StoredDocumentDO, ApiError>> {
		return wrapper(baseClient.post(`/alerts`, documentAlert));
	}

	update(
		id: number,
		patch: DocumentAlertPatchDTO
	): Promise<Result<App.Data.Alerts.DocumentAlertDO, ApiError>> {
		return wrapper(baseClient.put(`alerts/${id}`, patch));
	}

	delete(id: number) {
		return wrapper<any>(baseClient.delete(`alerts/${id}`));
	}
	usages(
		id: number
	): Promise<Result<App.Data.Alerts.AlertUsagesDO, ApiError>> {
		return wrapper(baseClient.get(`alerts/${id}/usages`));
	}
	deleteNotifiable(documentAlertNotifiable: DocumentAlertNotifiableDO) {
		return wrapper<any>(
			baseClient.delete(
				`alerts/${documentAlertNotifiable.document_alert_id}/notifiable/${documentAlertNotifiable.id}`
			)
		);
	}
	assignNotifiableUser(
		document_alert_id: number,
		user_id: number
	): Promise<Result<App.Data.Alerts.DocumentAlertDO, ApiError>> {
		return wrapper(
			baseClient.put(`alerts/${document_alert_id}/notifiable/${user_id}`)
		);
	}
}
